export default __webpack_public_path__ + "static/PAPC-101-471e06870b1e9377b955a96a000ebdd4.jpg";